<template>
  <div class="single-container">
    <div class="single-image-wrapper">
      <img :src="imageUrl" />
    </div>

    <div class="single-answer-wrapper">
      {{ answer }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'Single',
  props: {
    choices: {
      type: Array,
      required: true
    },
    expectedResponse: {
      type: Object,
      required: true
    },
    image: {
      type: Object,
      required: true
    }
  },
  computed: {
    answer() {
      const label = this.choices[this.expectedResponse.choice].label

      return this.$t('tasting.section.summary.answers.single', {
        label
      })
    },
    imageUrl() {
      return this.image.fields.file.url
    }
  }
}
</script>

<style lang="scss" scoped>
.single-container {
  display: flex;
  flex-direction: row;
  flex-grow: 1;

  .single-image-wrapper {
    width: 30%;
    margin-right: 30px;

    img {
      width: 100%;
    }
  }

  .single-answer-wrapper {
    flex-grow: 1;
    font-size: 16px;
    text-align: left;
  }
}
</style>
